import React from "react";

import { HubButton } from "../../components";

const QuickWorkOrderSubmitButton = () => {
  return (
    <HubButton
      variant="contained"
      size="xsmall"
      type="submit"
      label="Update Work Order"
    />
  );
};

export default QuickWorkOrderSubmitButton;
